import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Fab, Grid, type Theme, useMediaQuery } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { PermissionArea } from '@pbt/pbt-ui-components'

import FeatureToggle from '~/constants/featureToggle'
import { getCRUDByArea } from '~/store/reducers/auth'
import { getFeatureToggle } from '~/store/reducers/constants'
import { addSearch } from '~/utils'

import WellnessPlanDetails from './details/WellnessPlanDetails'
import WellnessPlansTableComponent from './WellnessPlansTableComponent'
import WellnessPlansTableComponentNew from './WellnessPlansTableComponentNew'

const useStyles = makeStyles(
  () => ({
    button: {
      width: 132,
      height: 40,
    },
  }),
  { name: 'WellnessPlansListPage' },
)

const WellnessPlansListPage = () => {
  const classes = useStyles()
  const navigate = useNavigate()
  const location = useLocation()
  const { wellnessPlanVersionId } = useParams()
  const { t } = useTranslation('Common')

  const isWpAutoRenewalLinkingEnabled = useSelector(
    getFeatureToggle(FeatureToggle.WP_LINKING_AUTO_RENEWAL),
  )

  const permissions = useSelector(
    getCRUDByArea(PermissionArea.WELLNESS_PLAN_CONFIG),
  )

  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'))

  const onDetailsClose = () => {
    navigate(addSearch(location, '/admin/catalog/wellness-plans'))
  }

  if (isMobile && typeof wellnessPlanVersionId !== 'undefined') {
    return (
      <WellnessPlanDetails
        itemId={wellnessPlanVersionId}
        onClose={onDetailsClose}
      />
    )
  }

  const headerButtons = (
    <Grid container item justifyContent="flex-end" px={3} py={2}>
      <Fab
        className={classes.button}
        color="inherit"
        variant="extended"
        onClick={() => navigate('/admin/catalog/wellness-plans/create')}
      >
        {t('Common:NEW_VERSION')}
      </Fab>
    </Grid>
  )

  const Component = isWpAutoRenewalLinkingEnabled
    ? WellnessPlansTableComponentNew
    : WellnessPlansTableComponent

  return (
    <Grid container item flex={1} wrap="nowrap">
      <Component
        headerButtons={permissions.create && headerButtons}
        wellnessPlanVersionId={wellnessPlanVersionId}
        onDetailsClose={onDetailsClose}
      />
    </Grid>
  )
}

export default WellnessPlansListPage
